import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector, change } from 'redux-form';
import { FormattedMessage, injectIntl } from 'react-intl';
import {
  Button,
  Row,
  FormGroup,
  Col,
  ControlLabel,
} from 'react-bootstrap';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import CommonFormComponent from '../../CommonField/CommonFormComponent';
import CommomImageDisplay from '../CommonImageDisplay/CommomImageDisplay';
import MultiLanguageInput from '../MultiLanguageInput';

import messages from '../../../locale/messages';
import submit from './submit';
import validate from './validate';
import { url, banneruploadDir } from '../../../config';
import ImageUploadComponent from '../ImageUploadComponent/ImageUploadComponent';
import { doUploadImageBanner, startBannerUploaderLoader, stopBannerUploaderLoader } from '../../../actions/siteadmin/manageImageBanner';
import { photosShow } from '../../../helpers/photosShow';

import PictureImage from '/public/AdminIcons/default.svg'

import s from './ImageBannerForm.css';
import cp from '../../../components/commonStyle.css';

class ImageBannerForm extends Component {

  static propTypes = {
    initialValues: PropTypes.object,
    title: PropTypes.string.isRequired,
    bannerUploaderLoading: PropTypes.bool,
    doUploadImageBanner: PropTypes.any.isRequired
  };

  success = async (file, fromServer) => {
    const { image, startBannerUploaderLoader, stopBannerUploaderLoader, doUploadImageBanner } = this.props;
    let fileName = fromServer.file.filename;
    let oldImage = image != undefined ? image : null;
    await startBannerUploaderLoader();
    await doUploadImageBanner(fileName, oldImage);
    await stopBannerUploaderLoader();
  }

  handleFieldChange = (fieldName, value) => {
    const { dispatch } = this.props;
    dispatch(change('ImageBannerForm', fieldName, value));
  };

  render() {
    const { error, handleSubmit, submitting, dispatch, initialValues, title, image, bannerUploaderLoading, formValues } = this.props;
    const { formatMessage } = this.props.intl;
    let path = photosShow(banneruploadDir);

    // Hidden fields to register multilingual fields with Redux Form
    const multilingualFields = ['title', 'description', 'buttonLabel', 'buttonLabel2'];
    const langSuffixes = ['_en', '_fr', '_it', '_pt'];
    const hiddenFields = [];
    multilingualFields.forEach(base => {
      langSuffixes.forEach(suffix => {
        hiddenFields.push(
          <Field key={`${base}${suffix}`} name={`${base}${suffix}`} component="input" type="hidden" />
        );
      });
    });

    return (
      <div className='listPhotoContainer'>
        <div className={cx(s.pagecontentWrapper, 'pagecontentWrapperRTL', 'adminPhotoUplod', 'dzInputContainer')}>
          <div className={cx(cp.adminContentPadding)}>
            <div className={s.sectionCenter}>
              <div className={cp.commonAdminBorderSection}>
                <h1 className={s.headerTitle}><FormattedMessage {...messages.homepageBanner} /></h1>
                <form onSubmit={handleSubmit((values) => {
                  const payload = { ...values, ...formValues };
                  console.log('🚀 [ImageBannerForm] Sending:', payload);
                  return submit(payload, dispatch);
                })}>
                  {hiddenFields}
                  {error && <strong>{formatMessage(error)}</strong>}
                  <FormGroup className={s.space3}>
                    <Row>
                      <Col xs={12} sm={12} md={12} lg={12}>
                        <label className={cp.labelTextNew} ><FormattedMessage {...messages.adminBannerImage} /></label>
                      </Col>
                      <Col xs={12} sm={12} md={12} lg={12} className={cp.textAlignCenter}>
                        <div className={'uploadDropZoneSection'}>
                          <ImageUploadComponent
                            defaultMessage={formatMessage(messages.photosPlaceholder)}
                            componentConfig={{
                              iconFiletypes: ['.jpg', '.png'],
                              multiple: false,
                              showFiletypeIcon: false,
                              postUrl: '/uploadBanner'
                            }}
                            loaderName={'bannerUploaderLoading'}
                            success={this.success}
                          ></ImageUploadComponent>
                          <img src={PictureImage} alt="PictureImage" className={'uploadDropZoneSectionImage'} />
                        </div>
                        <CommomImageDisplay
                          loader={bannerUploaderLoading}
                          image={image && path + image}
                        />
                      </Col>
                    </Row>
                  </FormGroup>

                  {/* Title - Multi-language */}
                  <FormGroup className={s.space3}>
                    <ControlLabel className={cp.labelTextNew}>
                      <FormattedMessage {...messages.adminTitleLabel} />
                    </ControlLabel>
                    <MultiLanguageInput
                      baseField="title"
                      values={formValues}
                      onChange={this.handleFieldChange}
                      inputType="text"
                      placeholder={formatMessage(messages.adminTitleLabel)}
                    />
                  </FormGroup>

                  {/* Description/Subtitle - Multi-language */}
                  <FormGroup className={s.space3}>
                    <ControlLabel className={cp.labelTextNew}>
                      <FormattedMessage {...messages.descriptionAdminLabel} />
                    </ControlLabel>
                    <MultiLanguageInput
                      baseField="description"
                      values={formValues}
                      onChange={this.handleFieldChange}
                      inputType="textarea"
                      placeholder={formatMessage(messages.descriptionAdminLabel)}
                    />
                  </FormGroup>

                  {/* Button Label 1 - Multi-language */}
                  <FormGroup className={s.space3}>
                    <ControlLabel className={cp.labelTextNew}>
                      <FormattedMessage {...messages.buttonLabel} /> 1
                    </ControlLabel>
                    <MultiLanguageInput
                      baseField="buttonLabel"
                      values={formValues}
                      onChange={this.handleFieldChange}
                      inputType="text"
                      placeholder={formatMessage(messages.buttonLabel) + ' 1'}
                    />
                  </FormGroup>

                  {/* Button Link 1 - NOT multilingual */}
                  <FormGroup className={s.space3}>
                    <ControlLabel className={cp.labelTextNew}>
                      <FormattedMessage {...messages.buttonLink} /> 1
                    </ControlLabel>
                    <Field name="buttonLink1" type="text" component={CommonFormComponent} isAddon={true} suffixLabel={url} label={formatMessage(messages.buttonLink) + ' 1'} inputClass={cx(cp.formControlInput)} />
                  </FormGroup>

                  {/* Button Label 2 - Multi-language */}
                  <FormGroup className={s.space3}>
                    <ControlLabel className={cp.labelTextNew}>
                      <FormattedMessage {...messages.buttonLabel} /> 2
                    </ControlLabel>
                    <MultiLanguageInput
                      baseField="buttonLabel2"
                      values={formValues}
                      onChange={this.handleFieldChange}
                      inputType="text"
                      placeholder={formatMessage(messages.buttonLabel) + ' 2'}
                    />
                  </FormGroup>

                  {/* Button Link 2 - NOT multilingual */}
                  <FormGroup className={s.space3}>
                    <ControlLabel className={cp.labelTextNew}>
                      <FormattedMessage {...messages.buttonLink} /> 2
                    </ControlLabel>
                    <Field name="buttonLink2" type="text" component={CommonFormComponent} isAddon={true} suffixLabel={url} label={formatMessage(messages.buttonLink) + ' 2'} inputClass={cx(cp.formControlInput)} />
                  </FormGroup>

                  <FormGroup className={s.noMargin}>
                    <Row>
                      <Col xs={12} sm={12} md={12} lg={12} className={cx(cp.textAlignRight, 'textAlignLeftRTL')}>
                        <Button bsSize="small" className={cx(cp.btnPrimary, cp.btnlarge)} type="submit" disabled={submitting} >
                          <FormattedMessage {...messages.save} />
                        </Button>
                      </Col>
                    </Row>
                  </FormGroup>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div >
    );
  }

}

ImageBannerForm = reduxForm({
  form: 'ImageBannerForm', // a unique name for this form
  validate,
  enableReinitialize: true,
  keepDirtyOnReinitialize: false
})(ImageBannerForm);

const selector = formValueSelector('ImageBannerForm');

const getMultiLangFields = (state, baseFields) => {
  const result = {};
  const langs = ['', '_en', '_fr', '_it', '_pt'];
  baseFields.forEach(field => {
    langs.forEach(lang => {
      const fieldName = `${field}${lang}`;
      result[fieldName] = selector(state, fieldName);
    });
  });
  return result;
};

const mapState = (state) => ({
  bannerUploaderLoading: state.loader.bannerUploaderLoading,
  formValues: getMultiLangFields(state, ['title', 'description', 'buttonLabel', 'buttonLabel2'])
});

const mapDispatch = {
  startBannerUploaderLoader,
  doUploadImageBanner,
  stopBannerUploaderLoader,
  change
};

export default injectIntl(withStyles(s, cp)(connect(mapState, mapDispatch)(ImageBannerForm)));